module.exports = __webpack_public_path__ + "static/media/vacuum.6adba806.glb";